<div class="container not-found-page">
  <div class="row">
    <div class="col">
      <h1>404</h1>
      <p>Page not found</p>
      <p><a routerLink="/">Go to home page</a></p>
    </div>
  </div>
</div>
